module.exports = __webpack_public_path__ + "static/img/random-money-icon.8b5f46bb.png";